export default {
    brand_name: '',
    employURL: '',
    privacyURL: '',
    baseYM: 'yd-out.jmkjsh.com',
    baseURL: 'https://yd-out.jmkjsh.com',
    baseURLFile: 'https://convert-test.shanghaijimu.com',
    baseURLWPS: 'https://wps.shanghaijimu.com',
    wss: 'wss:/yd-out.jmkjsh.com/ws/tts'
};
